import { motion } from "framer-motion";

/**
 * MaskedLines — renders lines of text with an overflow-hidden mask
 * and animates each line from y:100% to y:0 with an editorial feel.
 *
 * children can be a single string per line, or React nodes (span with italic serif class).
 * Provide `lines` prop as an array of React nodes.
 */
export default function MaskedLines({
  lines,
  delay = 0,
  className = "",
  as: Tag = "h1",
  stagger = 0.09,
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{
              duration: 1.05,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
            className="inline-block will-change-transform"
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
